<template>
  <div class="empty-state flex flex-col items-center justify-center">
    <slot name="content">
      <lf-h4>{{ $t("DEAL_ACTIVITY.EMPTY.TITLE") }}</lf-h4>
      <span>{{ $t("DEAL_ACTIVITY.EMPTY.SUBTITLE") }}</span>
    </slot>
  </div>
</template>
<script setup lang="ts">
import LfH4 from "@/components/ui/text/LfHeading4.vue";
</script>
<style scoped>
@reference "@/assets/tailwind.css";

/**
  visible content (header, input) height:
  desktop - 300px
  mobile - 130px
*/

.empty-state {
  @apply h-[calc(100vh-300px)];
}

@container (max-height: 430px) {
  .empty-state {
    height: calc(100% - 130px);
  }
  .empty-state svg {
    display: none !important;
  }
}

@container (max-height: 350px) {
  .empty-state h3,
  .empty-state div {
    @apply mt-0 text-xs leading-normal;
  }
}
</style>
